import { compact, map, split, trim } from "lodash";

const termString = `
  Serie
  Nest
  Gewürz
  Elefant
  Karneval
  
  Misserfolg
  Geschichte
  Bier
  Disco
  Präsident
  
  Solitär
  Kartoffel
  Welle
  Schule
  Lego
  
  Schatz
  Pilot
  Micky
  Kanalisation
  Galaxie
  
  Stoff
  Vampir
  Monopoly
  Manga
  Hotel
  
  König
  Ballett
  Band
  Alkohol
  Lava
  
  Gefängnis
  Loch
  Punk
  Abend
  Karte
  
  Mumie
  Batterie
  Rummel
  Karate
  Papagei
  
  Mythos
  Facebook
  Eichel
  Gräte
  Brücke
  
  Marionette
  Spiel
  Vegas
  Truhe
  Flugzeug
  
  Handtuch
  Venus
  Krake
  Zyklus
  Oper
  
  Dinosaurier
  Gelb
  Pilz
  Taube
  Pikachu
  
  Zucker
  Theater
  Schaufel
  Enterprise
  Lautsprecher
  
  Schnurrbart
  Blase
  Kette
  Stark
  Keks
  
  Croissant
  Geist
  Stroh
  Nagel
  Potter
  
  Darwin
  Tomate
  Fallschirm
  Kanone
  Fernglas
  
  Fata Morgana
  Ramses
  Feuer
  Kreuzung
  Prinzessin
  
  Raumschiff
  Bowling
  Churchill
  Widder
  Spion
  
  Nitendo
  Wette
  Salz
  Handbuch
  Gel
  
  Hammer
  Chile
  Blutwurst
  Kaiser
  Papst
  
  Mund
  Karussell
  Psycho
  Gras
  Sturz
  
  Ofen
  Griff
  Ostern
  Schlauch
  Schiene
  
  Hausschuh
  Blatt
  Puma
  Revolution
  Sahara
  
  Alcatraz
  Rauch
  Haselnuss
  Diamant
  Rose
  
  Barbie
  Schokolade
  Schnee
  Krawatte
  Wind
  
  Schnitzel
  Kanada
  Zoo
  Pfeife
  Buch
  
  Zug
  Sardine
  Stück
  Kleopatra
  Fenster
  
  Ritter
  Frieden
  Blume
  Schweiz
  Kalender
  
  Muschel
  Shakespeare
  Riese
  Schaum
  Keller
  
  Messer
  Kissen
  Armstrong
  Schwert
  Flug
  
  Caesar
  Nudel
  Hut
  Zahnarzt
  Weizen
  
  Ticket
  Pinguin
  Zelle
  Gandhi
  Oase
  
  Krokodil
  Schmuck
  U-Bahn
  Brille
  Falco
  
  Jackson
  Zigarette
  Armband
  Wetterbericht
  Turm
  
  Tattoo
  Spielberg
  Apfel
  Meerjungfrau
  Boxen
  
  Zwerg
  Zirkus
  Elvis
  Rasenmäher
  Stein
  
  Musik
  Hals
  Amerika
  Kaffee
  Fieber
  
  Pfeffer
  Dreieck
  Puppe
  Italien
  Bühne
  
  Gift
  Stern
  Wolf
  Lena
  Geburtstag
  
  Bäcker
  Parfum
  Flamme
  Zombie
  Joker
  
  Buffy
  Vulkan
  Leidenschaft
  Hahn
  Elektrizität
  
  Genie
  Dracula
  Löwe
  Socke
  Freitag
  
  Pirat
  Ferien
  Elfe
  Magnet
  Gabel
  
  Sirup
  Wald
  Waage
  Zeus
  Kakerlake
  
  Cocktail
  Mario
  Korken
  Geige
  Pfirsich
  
  Fuchs
  Polizei
  Simpson
  Donut
  Zeitung
  
  Berge
  Erdnuss
  Glühbirne
  Jedi
  Chilli
  
  Sombrero
  Kleeblatt
  Taste
  Käse
  Chewbacca
  
  Revolver
  Doktor
  Erdbeere
  Kernkraft
  Lotterie
  
  Friedhof
  Amor
  Regenschirm
  Sprung
  Wurzel
  
  Tokio
  Ferse
  Huhn
  Helikopter
  Offizier
  
  Blitz
  Garten
  Malerei
  Hütte
  Reformation
  
  Stock
  Musketier
  Faden
  Tulpe
  Ikea
  
  Rache
  Chef
  Notfall
  Kreuz
  Walzer
  
  Kran
  Operation
  Rap
  Muse
  Verteidigung
  
  Granatapfel
  Füllung
  Bürste
  Schwein
  Avicii
  
  Pumpe
  Aladdin
  Rohr
  Gürtel
  Bar
  
  Leiter
  Engel
  Narr
  Haar
  Matrix
  
  Plastik
  Rochen
  Karton
  Kiesel
  Everest
  
  Beere
  Untersuchung
  Gotik
  Titanic
  Maschine
  
  Asterix
  Roboter
  Komödie
  Sprache
  Friseur
  
  Reggae
  Mist
  See
  Affe
  Leuchtturm
  
  Bild
  Feuerwehr
  Glas
  Kloß
  Griechenland
  
  Hollywood
  Mücke
  Lanze
  Börse
  Ende
  
  Club
  Weihnachten
  Nähen
  Bahnhof
  Lampe
  
  Zweig
  Cinderella
  Pfannkuchen
  Insel
  Taxi
  
  Wikinger
  Alarm
  Tanz
  Hulk
  Wüste
  
  Licht
  Sofa
  Mozart
  Ring
  Pizza
  
  Kiste
  PlayStation
  Blond
  Iris
  Mitglied
  
  Tradition
  Schlange
  Pokal
  Picasso
  Uhr
  
  Herz
  Moskau
  Billard
  Einhorn
  Orange
  
  Olympiade
  Klettern
  Anwalt
  Tolkien
  Fluss
  
  Teppich
  Pony
  Krone
  Neu
  Tarantino
  
  Melone
  Anker
  Israel
  Kaktus
  Tennis
  
  Gedanke
  Frankenstein
  Strahl
  Akzent
  Dusche
  
  Schnur
  Australien
  Schloss
  Wache
  Schaf
  
  Marienkäfer
  Senf
  Sherlock
  Flasche
  Virus
  
  Torte
  Hengst
  Mexiko
  Weiß
  Glatze
  
  Eisen
  Batman
  Lied
  Nil
  Kino
  
  Pfingsten
  Gummi
  Topf
  Flash
  Tunnel
  
  Fleece
  Maus
  Kette
  Bauernhof
  Belgien
  
  Avatar
  Mühle
  Dschungel
  Nonne
  Böller
  
  Ratte
  Zange
  Amazon
  Tabak
  Regel
  
  Haus
  Pate
  Krieg
  Seil
  Wein
  
  Schraube
  Harke
  Computer
  Nespresso
  Ball
  
  Doping
  Knoblauch
  Würfel
  Rocky
  Milch
  
  Radio
  Birne
  Gladiator
  Sonne
  Getreide
  
  Grillen
  Panda
  Traum
  Ehe
  Nabel
  
  Ziege
  Brot
  Teufel
  Grundschule
  Tarzan
  
  Tango
  Brombeere
  Tempel
  Sand
  Pommes
  
  Spartakus
  Fell
  Tornado
  Pyramide
  Ehering
  
  Terminator
  Brief
  Kugel
  Paradies
  Ei
  
  Schmetterling
  Puder
  Porzellan
  Markt
  Kokon
  
  Katze
  Palast
  Wahl
  Honig
  Rambo
  
  Godzilla
  Uniform
  Regen
  Brand
  Helm
  
  Raupe
  Humor
  Ecke
  Antarktis
  Würstchen
  
  Karies
  Ärmel
  Gremlins
  Poker
  Kuchen
  
  Spiegel
  Silvester
  Bad
  Kern
  Fee
  
  Gehirn
  Maske
  Konzert
  Troja
  Hai
  
  Segeln
  Camembert
  Shrek
  Pol
  Western
  
  Stadtviertel
  Rock
  Tiger
  Nadel
  Seife
  
  Halloween
  Chip
  Baby
  Feldflasche
  Paar
  
  Eis
  Flöte
  Champagner
  Safari
  Alien
  
  Google
  Bogen
  Mars
  Golf
  Ticket
  
  Frankreich
  Mond
  Kantine
  Kaiserpinguin
  Werkzeug
  
  Mafia
  Groß
  Rakete
  Microsoft
  Ski
  
  Scheiterhaufen
  Zauberer
  Hockey
  Banane
  Helene
  
  Nummer
  Triathlon
  Rum
  Metal
  Thunfisch
  
  Heino
  Ninja
  Bettdecke
  Jäger
  Gemüse
  
  Höhle
  Hans
  Casino
  Bonbon
  Brunnen
  `;

const terms = compact(map(split(termString, /\r\n|\r|\n/), trim));

export const getTerm = () => {
  const index = Math.floor(Math.random() * terms.length);
  return terms[index];
};
